import { compact } from 'lodash/fp';

import type { CmsInsuranceTypeContent } from '../../types';

type GetAllQuestions = {
  cmsData: Partial<CmsInsuranceTypeContent>;
};

const getAllQuestions = ({ cmsData }: GetAllQuestions) => {
  const questions = cmsData?.questions ?? [];
  const commonQuestionsAlternate = cmsData?.commonQuestions?.questions || [];
  return compact([...questions, ...commonQuestionsAlternate]);
};

export default getAllQuestions;
